

import Api from './Api.service';
export default class NotificacionService {

    static ObtenerActivas() {
        return Api.get('notificaciones');
    }

    static DesactivarTodas() {
        return Api.post('notificaciones/desactivar', {});
    }


}
